import React from "react";
import { Link } from "react-router-dom";
import Layout from "../Auth/Includes/layout";
import Navbar from "../Auth/Includes/Navbar/navbar";
import FormBox from "../../Components/Auth/FormBox/formBox";
import LogoCazco from "../../assets/images/logo_cazco.svg";
import "./Includes/Loader/Loader.css";
import ResetPasswordForm from "../../Components/Auth/ResetPasswordForm/resetPasswordForm";
import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const ResetPassword = () => {
  const { t } = useTranslation("home");

  return (
    <Layout>
      <div className="pagesAuth accountbg"></div>
      <Navbar />
      <FormBox>
        <div className=" mt-4 d-flex" id="cardLogoTexto">
          <Col xs={4}>
            <Link to="/" className="logo-admin" id="logo">
              <img src={LogoCazco} height="50" alt="logo" />
            </Link>
          </Col>
          <Col xs={8}>
            <div className=" text-right" id="texto">
              <h4 className="pagesAuth font-18 m-b-5 text-bold text-dark">
                {t("welcome")}
              </h4>
              <p className="pagesAuth font-12 text-dark">{t("loginAdvise")} </p>
            </div>
          </Col>
        </div>
        <div className="p-3 mt-2">
          <ResetPasswordForm />
        </div>

        <div className="pagesAuth form-group mt-2 mb-3 row">
          <div className="col-12 text-center">
            <Link to={"/"} className="text-muted">
              <i className="text-muted mdi mdi-lock mr-2"></i>
              {t("forgotPassword")}{" "}
            </Link>
          </div>
        </div>
      </FormBox>
    </Layout>
  );
};

export default ResetPassword;
